import React, {FC} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
type InputProps = {
  progress: number
  handleClose?: () => void
  text?: string
  hasClose?: boolean
}

const Poppup: FC<InputProps> = ({progress, text = '', handleClose, hasClose = false, ...props}) => {
  return (
    <div className='KHIPU_poppup'>
      <div className='KHIPU_poppup-content'>
        {hasClose && (
          <div className='d-flex justify-content-end'>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={handleClose}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
        )}
        <div className='poppup-loaders'>
          <div className='poppup-loader'>
            <div className='loader-inner ball-scale-ripple-multiple'>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div className='poppup_body_text'>{text !== '' && <p>{text}</p>}</div>
        <div className='progress-container'>
          <div className='progress-bar' style={{width: `${progress}%`}}>
            <span>{`${progress}%`}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Poppup
